import { render, staticRenderFns } from "./InfraPXDashboard.vue?vue&type=template&id=3bd77a33&"
import script from "./InfraPXDashboard.vue?vue&type=script&lang=js&"
export * from "./InfraPXDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports